// Define action types with discriminated unions
type FetchNetworkIdAction = {
  type: "FETCH_NETWORK_ID";
  data: string | null;
};

type FetchNFTContractInstanceAction = {
  type: "NFT_CONTRACT_INSTANCE";
  data: object | null;
};

interface Web3Data {
  isLoggedIn: boolean;
  accounts: string[];
}

type FetchWeb3DataAction = {
  type: "FETCH_WEB3_DATA";
  data: Web3Data;
};

type FetchWeb3DataErrorAction = {
  type: "FETCH_WEB3_DATA_ERROR";
  data: Web3Data;
};

// Define a base action for other Redux actions with proper typing
type OtherAction = {
  type: string;
  data?: unknown; // Replace any with unknown for better type safety
};

// Union types for actions with proper type guards
type NetworkIdAction = FetchNetworkIdAction | OtherAction;
type NFTContractAction = FetchNFTContractInstanceAction | OtherAction;
type Web3DataAction =
  | FetchWeb3DataAction
  | FetchWeb3DataErrorAction
  | OtherAction;

// Reducer functions with proper typing
export function fetchNetworkId(
  state: string | null = null,
  action: NetworkIdAction
): string | null {
  switch (action.type) {
    case "FETCH_NETWORK_ID":
      return (action as FetchNetworkIdAction).data;
    default:
      return state;
  }
}

export function fetchNFTContractInstance(
  state: object | null = null,
  action: NFTContractAction
): object | null {
  switch (action.type) {
    case "NFT_CONTRACT_INSTANCE":
      return (action as FetchNFTContractInstanceAction).data;
    default:
      return state;
  }
}

export function fetchWeb3Data(
  state: Web3Data = {
    isLoggedIn: localStorage.getItem("RwaAuthToken") ? true : false,
    accounts: [localStorage.getItem("userAddress") || ""],
  },
  action: Web3DataAction
): Web3Data {
  switch (action.type) {
    case "FETCH_WEB3_DATA":
      return (action as FetchWeb3DataAction).data;
    case "FETCH_WEB3_DATA_ERROR":
      return (action as FetchWeb3DataErrorAction).data;
    default:
      return state;
  }
}
